import {
  Component,
  Inject,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

interface ModalData {
  mensagem: string;
  complemento: string;
}

@Component({
  selector: "up-modal-remover",
  templateUrl: "./modal-remove.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalRemoveComponent implements OnInit {
  @Input() isRemoving: boolean = true;
  @Input() active: boolean = true;
  @Input() description: string = "";
  @Input() haveDescription: boolean = false;

  constructor(
    public _dialogRef: MatDialogRef<ModalRemoveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
  ) {}

  ngOnInit() {}

  onClick(): void {
    this._dialogRef.close();
  }

  cancelar() {
    this._dialogRef.close();
  }
}
